import { useLocalStorage } from '@monofront/business/hooks';
import { v4 as uuid } from 'uuid';
import { useEffect } from 'react';

const useDeviceId = (): string => {
  const [deviceId, setDeviceId] = useLocalStorage<string>('lfDeviceId', '');

  useEffect(() => {
    if (!deviceId) {
      setDeviceId(uuid().toString());
    }
  }, []);

  return deviceId;
};

export default useDeviceId;
